import React, { useState } from 'react';

import DateCalendar from './components/DateCalendar';
import ScheduleForm from './components/ScheduleForm';
import ScheduleFeedback from './components/ScheduleFeedback';

import { FirstSection, SecondSection } from './styles';

const MonthPlaylistSubPage = ({ setSubPage, subPage }) => {
  const [selectedDate, setSelectedDate] = useState({
    year: '',
    month: '',
    day: '',
    isoDate: '',
  });

  const [fullPlaylistSchedule, setFullPlaylistSchedule] = useState([]);
  const [PlaylistNameAndData, setPlaylistNameAndData] = useState({});

  return (
    <>
      <FirstSection>
        <h1>Playlist mensal</h1>
        <DateCalendar
          setSubPage={setSubPage}
          subPage={subPage}
          setSelectedDate={setSelectedDate}
          fullPlaylistSchedule={fullPlaylistSchedule}
          PlaylistNameAndData={PlaylistNameAndData}
          setPlaylistNameAndData={setPlaylistNameAndData}
        />
      </FirstSection>
      <SecondSection>
        <ScheduleForm
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />
        <ScheduleFeedback
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          setFullPlaylistSchedule={setFullPlaylistSchedule}
          fullPlaylistSchedule={fullPlaylistSchedule}
          PlaylistNameAndData={PlaylistNameAndData}
          setPlaylistNameAndData={setPlaylistNameAndData}
        />
        {/* Modal */}
      </SecondSection>
    </>
  );
};

export default MonthPlaylistSubPage;
